import { VariantOrCampaign } from 'models/CampaignVariant'
import { createContext, useContext } from 'react'

type ContextT = {
  config: VariantOrCampaign
  setConfig: (VariantOrCampaign) => void
  readOnly?: boolean
}

// Fail-closed: default to read-only when Provider is missing so that
// components rendered outside the Provider (tests, storybook, refactors)
// never silently grant edit access.
export function useBuilderReadOnly(): boolean {
  const value = useContext(Context)
  if (value === null) return true
  return value.readOnly ?? false
}

const Context = createContext<ContextT | null>(null)

export function useCampaignConfig() {
  const value = useContext(Context)

  if (value === null) {
    const errorInfo =
      'useCampaignConfig must be used within a CampaignConfigContext.Provider'
    throw errorInfo
  }

  return value
}

export default Context
